export class TextInputValidator {
    static isTextInputBlank(input) {
        return !input;
    }
}
